import { performCmdbPostRequest } from '@atlassian/jira-servicedesk-cmdb-client/src/fetch.tsx';
import { getCmdbQueryLanguageValidateUrl } from '@atlassian/jira-servicedesk-cmdb-rest-urls/src/common/constants/query-language.tsx';
import type { WorkspaceId } from '@atlassian/jira-servicedesk-insight-shared-types/src/common/types/shared-types/index.tsx';
import {
	type ValidResult,
	type InvalidResult,
	toValidatedIql,
	type IqlValidationResponse,
} from '../common/types.tsx';

export const validateQlQuery = async ({
	workspaceId,
	unvalidatedIql,
}: {
	workspaceId: WorkspaceId;
	unvalidatedIql: string;
}): Promise<ValidResult | InvalidResult> => {
	const queryLanguageKey = 'qlQuery';
	const { isValid, errorMessages }: IqlValidationResponse = await performCmdbPostRequest(
		getCmdbQueryLanguageValidateUrl(workspaceId),
		{
			body: JSON.stringify({
				context: 'ADVANCED_SEARCH',
				[queryLanguageKey]: unvalidatedIql,
			}),
		},
	);

	if (isValid) {
		return {
			type: 'valid',
			validatedIql: toValidatedIql(unvalidatedIql),
		};
	}
	return {
		type: 'invalid',
		error: errorMessages.join(''),
	};
};
